module.exports = __webpack_public_path__ + "static/1-a6f89299122b7abd2f8fe423a2431577.jpg";